import { FeedbackPromptResponseDetails } from "./EmployeeFeedbackModel";
import { FeedbackPromptComments } from "./newJoinerFeedbackModel";
//MyTESupervisoryNudge Prompt -> On submission records get updated in Dipa database.
export class MyTENudgeModel {
    EnterpriseId!: string;
    CardUniqueId!: string;
    CategoryType!: string;
    ChannelType!: string;
    FeedbackPromptResponseDetails !: FeedbackPromptResponseDetails[];
    FeedbackPromptComments!: FeedbackPromptComments[];
    IsPostAnonymous!: boolean;
}
